<template>
    <span class="icon icon_chevron_down">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.96002 7.42116C3.56027 7.80224 3.54514 8.43522 3.92622 8.83497L11.2762 16.545C11.465 16.7429 11.7265 16.855 12 16.855C12.2735 16.855 12.5351 16.7429 12.7238 16.545L20.0738 8.83498C20.4549 8.43524 20.4398 7.80225 20.04 7.42117C19.6403 7.04009 19.0073 7.05522 18.6262 7.45497L12 14.4057L5.37383 7.45495C4.99275 7.05521 4.35976 7.04008 3.96002 7.42116Z"
                  :fill="color"/>
        </svg>
    </span>
</template>

<script lang="ts">
export default {
    name: 'IconChevronDown',
    props: {
        color: {
            type: String,
            default: '#1A1A1A',
        },
    },
};
</script>

<style scoped lang="scss">
.icon_chevron_down {
    display: inline-block;
    font-size: 0;
    width: 24px;
    height: 24px;

    svg {
        width: 100%;
        height: 100%;
    }
}
</style>
